import { forwardRef } from "react";

import dynamic from "next/dynamic";

import { BaseInputProps } from "./types";

// Disabled SSR to avoid memory leak caused by styled
const DynamicDashboardBaseInput = dynamic(
  () => import("./DashboardBaseInputSsr").then((mod) => mod.DashboardBaseInputSsr),
  { ssr: false }
);

// Wrap dynamic component with forwardRef and pass ref as forwardedRef prop
// This is necessary because next/dynamic doesn't properly forward refs
export const DashboardBaseInput = forwardRef<HTMLInputElement, BaseInputProps>((props, ref) => (
  <DynamicDashboardBaseInput {...props} forwardedRef={ref} />
));

DashboardBaseInput.displayName = "DashboardBaseInput";
